'use es6';

import PropTypes from 'prop-types';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { previewEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import { SaveBarContainer } from 'customer-data-properties/savebar/SaveBarContainer';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import RecordLink from 'crm-links/record/RecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UniversalSidebarPreviewFooter = ({
  objectTypeId,
  objectId,
  readOnly,
  hasErrors,
  hasChanges,
  isLoading,
  handleSave,
  handleCancel
}) => {
  if (readOnly) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIPanelFooter, {
    "data-test-id": "preview-footer",
    className: "p-x-4",
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      justify: "between",
      className: "width-100",
      verticalGap: 14,
      children: [/*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: isLoading || hasErrors || !hasChanges,
          onClick: handleSave,
          "data-selenium-test": "PreviewSaveBar-button-primary",
          "data-test-id": "UniversalSidebarPreviewFooter-save",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "universalSidebarPreviewFooter.save"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          disabled: !hasChanges,
          "data-selenium-test": "PreviewSaveBar-button",
          "data-test-id": "UniversalSidebarPreviewFooter-cancel",
          onClick: handleCancel,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "universalSidebarPreviewFooter.cancel"
          })
        })]
      }), /*#__PURE__*/_jsx("span", {
        "data-selenium-test": "preview-footer-view-record",
        children: /*#__PURE__*/_jsx(RecordLink, {
          objectId: parseInt(objectId, 10),
          objectTypeId: ObjectTypesToIds[objectTypeId] || objectTypeId,
          hideIfNotSupported: true,
          skeletonWidth: 90,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "universalSidebarPreviewFooter.viewRecord"
          })
        })
      })]
    })
  });
};
UniversalSidebarPreviewFooter.propTypes = {
  objectTypeId: PropTypes.string.isRequired,
  objectId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  // from SaveBarContainer
  hasErrors: PropTypes.bool.isRequired,
  hasChanges: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};
export default SaveBarContainer(UniversalSidebarPreviewFooter, previewEditableAreas);